// @ts-nocheck
import React, { Component } from 'react';
import { Container } from '@mui/material';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <div>
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
